function onlyNumbers(s: string) {
  return s.replace(/\D+/g, '')
}

function phoneMaskWithDdd(s: string) {
  let numbers = onlyNumbers(s)

  if (numbers.length >= 10) {
    numbers = numbers.replace(/^0/, '')
    return numbers.length >= 11
      ? numbers.replace(/(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3')
      : numbers.replace(/(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3')
  }

  if (numbers.length >= 9) return numbers.replace(/(\d{5})(\d{4}).*/, '$1-$2')
  if (numbers.length >= 8) return numbers.replace(/(\d{4})(\d{4}).*/, '$1-$2')
  if (numbers.length >= 5) return numbers.replace(/(\d{4})(\d+)/, '$1-$2')

  return numbers
}

function CPFMask(s: string) {
  if (s.length > 14) {
    s = s.slice(0, 14)
  }
  return onlyNumbers(s)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3}\.\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3}\.\d{3}\.\d{3})(\d)/, '$1-$2')
}

function CNSMask(s: string) {
  s = onlyNumbers(s)
  if (s.length > 15) {
    s = s.slice(0, 15)
  }

  return s
    .replace(/(\d{3})(\d)/, '$1 $2')
    .replace(/(\d{3}) (\d{4})(\d)/, '$1 $2 $3')
    .replace(/(\d{3}) (\d{4}) (\d{4})(\d)/, '$1 $2 $3 $4')
}

function isDateWithTime(s: string): boolean {
  // Verifica se contém informações de tempo (formato ISO com T ou espaço seguido de hora)
  return /\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(s) || /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}/.test(s)
}

function simpleDateMask(s: string) {
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoMatch) {
    return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`
  }

  // Remove caracteres não numéricos e barras
  s = s.replace(/[^0-9/]/g, '')

  // Aplica máscara DD/MM/YYYY
  return s.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3')
}

function dateTimeMask(s: string) {
  // Formato ISO: YYYY-MM-DDTHH:MM:SS ou YYYY-MM-DD HH:MM:SS
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/)
  if (isoMatch) {
    return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]} ${isoMatch[4]}:${isoMatch[5]}`
  }

  // Formato brasileiro com tempo: DD/MM/YYYY HH:MM
  const brMatch = s.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/)
  if (brMatch) {
    return s // Já está no formato correto
  }

  // Se não conseguir fazer parse, tenta aplicar máscara básica
  s = s.replace(/[^0-9/: ]/g, '')

  // Tenta aplicar máscara DD/MM/YYYY HH:MM
  const timeMatch = s.match(/(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})/)
  if (timeMatch) {
    return `${timeMatch[1]}/${timeMatch[2]}/${timeMatch[3]} ${timeMatch[4]}:${timeMatch[5]}`
  }

  return s
}

function dateMask(s: string) {
  if (isDateWithTime(s)) {
    return dateTimeMask(s)
  }
  return simpleDateMask(s)
}

function WeightMask(s: string) {
  if (s === 'underweight') return 'Abaixo do peso'
  if (s === 'normalWeight') return 'Normal'
  if (s === 'overweight') return 'Sobrepeso'
  return 'Não informado'
}

function WeightMaskFormat(s: string) {
  if (!s || s === '0' ) return 'Não informado'
  const weight = Number(s)
  console.log('Parsed weight:', weight, s)
  if (isNaN(weight)) return 'Não informado'
  return `${weight} kg`
}

function HeightMask(s:  string) {
  if (!s || s === '0') return 'Não informado'
  const height = Number(s)
  if (isNaN(height)) return 'Não informado'
  return `${height / 100} m`
}

function administrationRouteMask(s: string) {
  if (!s) return 'Não informado'
  if (s === 'oral') return 'Oral'
  if (s === 'parenteral') return 'Parenteral'
  if (s === 'local') return 'Local'
  if (s === 'others') return 'Outros'
  if (s === 'buccal') return 'Bucal'
  if (s === 'capillary') return 'Capilar'
  if (s === 'dermatological') return 'Dermatológico'
  if (s === 'epidural') return 'Epidural'
  if (s === 'inhalation') return 'Inalação'
  if (s === 'nasalInhalation') return 'Inalação nasal'
  if (s === 'oralInhalation') return 'Inalação oral'
  if (s === 'intraarterial') return 'Intraarterial'
  if (s === 'intraarticular') return 'Intra-articular'
  if (s === 'intradermal') return 'Intradérmica'
  if (s === 'intramuscular') return 'Intramuscular'
  if (s === 'intrathecal') return 'Intratecal'
  if (s === 'intrauterine') return 'Intrauterino'
  if (s === 'intravenous') return 'Intravenoso'
  if (s === 'irrigation') return 'Irrigação'
  if (s === 'nasal') return 'Nasal'
  if (s === 'ophthalmic') return 'Oftálmico'
  if (s === 'otological') return 'Otológico'
  if (s === 'rectal') return 'Retal'
  if (s === 'subcutaneous') return 'Subcutâneo'
  if (s === 'sublingual') return 'Sublingual'
  if (s === 'transdermal') return 'Transdérmico'
  if (s === 'urethral') return 'Uretral'
  if (s === 'vaginal') return 'Vaginal'
  return 'Não informado'
}
  

function HomelessTime(s: string) {
  if (s === 'lessThanSixMonths') return 'Menos de 6 meses'
  if (s === 'sixToTwelveMonths') return 'Entre 6 meses e 1 ano'
  if (s === 'oneToFiveYears') return 'Entre 1 e 5 anos'
  if (s === 'moreThanFiveYears') return 'Mais de 5 anos'
  return 'Não informado'
}
function CEPMask(s: string) {
  s = onlyNumbers(s)

  s = s.replace(/^(\d{5})(\d{3}).*/, '$1-$2')

  return s
}

function CNPJMask(s: string) {
  s = onlyNumbers(s)

  s = s.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5')

  return s
}

function RegistrationStatusMask(value: string) {
  if (value === 'active') return 'Ativa'
  if (value === 'inapt') return 'Inapta'
  if (value === 'extinct') return 'Extinta'
}

function companySizeMask(value: string) {
  if (value === 'micro') return 'Microempresa'
  if (value === 'other') return 'Outro porte'
  if (value === 'small') return 'Pequena empresa'
  if (value === 'unknown') return 'Porte desconhecido'
}

function SexMask(value: string) {
  if (value === 'male' || value === 'Masculino') return 'Masculino'
  if (value === 'female' || value === 'Feminino') return 'Feminino'
  if (!value || value === 'unknown' || value === 'Não informado') return 'Não informado'
  return 'Outro'
}

function defaultSearchMask(key: string, content: Record<any, string>): string {
  if (key in content) {
    return content[key]
  }
  return 'Não informado'
}

export const applyMask = (value: string | boolean, mask: string) => {
  if (typeof value === 'boolean') {
    return value ? 'Sim' : 'Não'
  }
  switch (mask) {
    case 'phone':
      return phoneMaskWithDdd(value)
    case 'date':
      return dateMask(value)
    case 'dateOnly':
      return simpleDateMask(value)
    case 'dateTime':
      return dateTimeMask(value)
    case 'cep':
      return CEPMask(value)
    case 'sex':
      return SexMask(value)
    case 'cpf':
      return CPFMask(value)
    case 'cns':
      return CNSMask(value)
    case 'weight':
      return WeightMask(value)
    case 'heightMeter':
      return HeightMask(value)
    case 'weightKg':
      return WeightMaskFormat(value)
    case 'homelessTime':
      return HomelessTime(value)
    case 'cnpj':
      return CNPJMask(value)
    case 'currency':
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
        Number(value),
      )
    case 'registrationStatus':
      return RegistrationStatusMask(value)
    case 'companySize':
      return companySizeMask(value)
    case 'administrationRoute':
      return administrationRouteMask(value)
    default:
      return value
  }
}

export const detectMaskFromFieldName = (fieldName: string, fieldType?: string): string => {
  const lowerFieldName = fieldName.toLowerCase()

  // Verificar máscaras baseadas no nome do campo
  if (lowerFieldName.includes('cpf')) return 'cpf'
  if (lowerFieldName.includes('cns')) return 'cns'
  if (lowerFieldName.includes('cnpj')) return 'cnpj'
  if (
    lowerFieldName.includes('telefone') ||
    lowerFieldName.includes('phone') ||
    lowerFieldName.includes('celular')
  )
    return 'phone'
  if (lowerFieldName.includes('cep')) return 'cep'
  if (lowerFieldName.includes('sex') || lowerFieldName.includes('sexo')) return 'sex'
  if (
    lowerFieldName.includes('currency') ||
    lowerFieldName.includes('valor') ||
    lowerFieldName.includes('preco')
  )
    return 'currency'

  return ''
}
